export default __webpack_public_path__ + "static/media/zighini.c4577645.jpg";